module.exports = __webpack_public_path__ + "81f45615057a3ee5db5767bde47c54ef.jpg";